import {fnToastrFormError, printResponse} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnFieldsCompanyTable = function () {

    var tableName = '#datatable-fields-company';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    var columns = [
        {data: 'id'},
        {data: 'name'},
        {data: 'fields_company'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {visible: false, targets: 0},
        {width: "5%", targets: 1},
        {width: "5%", targets: 2},
    ];

    var table = $(tableName).DataTable({

        language: allLangFiles.datatables,
        rowId: 'id',
        ajax: {
            url: '/salary/company/table',
            dataSrc: function (json) {

                console.log(json);
                return json.data;
            },
        },
        columns: columns,
        columnDefs: columnDefs,
        order: [[1, 'asc']],
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            console.log(json.data);
        },
    });

    redesignDataTablesHeader(tableName);


    //Only turn tbody off at the top, not next handler!
    $(tableName + ' tbody').off('click', 'tr').on('click', 'tr', function () {

        var tableData = table.row(this).data();

        var modalName = '#modal-fields-company';
        var companyId = tableData.id;

        if (!element_exists(modalName)) {

            $.ajax({
                url: "/salary/company/" + companyId + '/edit',
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    var form = $('#form-update-fields-company');

                    form.off().on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize() + '&company_id=' + companyId;
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                printResponse(response);
                                modal.modal('hide');

                                table.ajax.reload(null, false);
                            },
                        })
                    });

                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                },
                error: fnToastrFormError
            });
        }
    });
};